import React from 'react';

/** A KPI tile on the storefront's Analytics / Affiliate Sales / Affiliate Deals tabs (storefront.scss). */
export const StatCard = ({ icon, label, value, tone }: { icon: React.ReactNode; label: string; value: any; tone: string }) => (
    <div className="brd-card brd-store-stat">
        <span className={`brd-store-stat__icon brd-store-stat__icon--${tone}`}>{icon}</span>
        <span className="brd-store-stat__label">{label}</span>
        <span className="brd-store-stat__value">{value}</span>
    </div>
);
